import { localStorage } from '@muse-web/storages'

export const NEXTJS_REG_PAYWALL_KEYS = {
    showRegPaywall: 'shouldShowRegistrationPayWall',
    audioIdToDownload: 'audio-id-to-download',
    collectionIdToDownload: 'collection-id-to-download',
    audacitySignupFlow: 'isAudacitySignupFlow',
    hqFlow: 'isHqFlow',
} as const

type TNextjsFlagKey =
    | typeof NEXTJS_REG_PAYWALL_KEYS.audacitySignupFlow
    | typeof NEXTJS_REG_PAYWALL_KEYS.hqFlow

const writeNextjsFlag = (key: TNextjsFlagKey, value: boolean): boolean => {
    try {
        window.localStorage.setItem(key, JSON.stringify(value))

        return true
    } catch {
        return false
    }
}

const readNextjsFlag = (key: TNextjsFlagKey): boolean => {
    try {
        const stored = window.localStorage.getItem(key)

        return stored !== null && JSON.parse(stored) === true
    } catch {
        return false
    }
}

export const writeNextjsAudacitySignupFlow = (isAudacitySignupFlow: boolean): boolean =>
    writeNextjsFlag(NEXTJS_REG_PAYWALL_KEYS.audacitySignupFlow, isAudacitySignupFlow)

export const readNextjsAudacitySignupFlow = (): boolean =>
    readNextjsFlag(NEXTJS_REG_PAYWALL_KEYS.audacitySignupFlow)

export const writeNextjsHqFlow = (isHqFlow: boolean): boolean =>
    writeNextjsFlag(NEXTJS_REG_PAYWALL_KEYS.hqFlow, isHqFlow)

export const readNextjsHqFlow = (): boolean => readNextjsFlag(NEXTJS_REG_PAYWALL_KEYS.hqFlow)

export type TNextjsPendingDownload = { audioId?: string; collectionId?: string }

export const handOverRegPaywallToNextjs = ({
    audioId,
    collectionId,
}: TNextjsPendingDownload = {}) => {
    localStorage.set(NEXTJS_REG_PAYWALL_KEYS.showRegPaywall, 'true', 'sessionStorage')

    if (audioId) {
        localStorage.set(NEXTJS_REG_PAYWALL_KEYS.audioIdToDownload, audioId, 'sessionStorage')
    }

    if (collectionId) {
        localStorage.set(
            NEXTJS_REG_PAYWALL_KEYS.collectionIdToDownload,
            collectionId,
            'sessionStorage',
        )
    }
}
